export const countryTelData = {
  "AF": { "name": "Afghanistan", "dial_code": "+93" },
  "AL": { "name": "Albania", "dial_code": "+355" },
  "DZ": { "name": "Algeria", "dial_code": "+213" },
  "AD": { "name": "Andorra", "dial_code": "+376" },
  "AO": { "name": "Angola", "dial_code": "+244" },
  "AG": { "name": "Antigua and Barbuda", "dial_code": "+1268" },
  "AR": { "name": "Argentina", "dial_code": "+54" },
  "AM": { "name": "Armenia", "dial_code": "+374" },
  "AU": { "name": "Australia", "dial_code": "+61" },
  "AT": { "name": "Austria", "dial_code": "+43" },
  "AZ": { "name": "Azerbaijan", "dial_code": "+994" },
  "BS": { "name": "Bahamas", "dial_code": "+1242" },
  "BH": { "name": "Bahrain", "dial_code": "+973" },
  "BD": { "name": "Bangladesh", "dial_code": "+880" },
  "BB": { "name": "Barbados", "dial_code": "+1246" },
  "BY": { "name": "Belarus", "dial_code": "+375" },
  "BE": { "name": "Belgium", "dial_code": "+32" },
  "BZ": { "name": "Belize", "dial_code": "+501" },
  "BJ": { "name": "Benin", "dial_code": "+229" },
  "BT": { "name": "Bhutan", "dial_code": "+975" },
  "BA": { "name": "Bosnia and Herzegovina", "dial_code": "+387" },
  "BR": { "name": "Brazil", "dial_code": "+55" },
  "BG": { "name": "Bulgaria", "dial_code": "+359" },
  "CA": { "name": "Canada", "dial_code": "+1" },
  "CH": { "name": "Switzerland", "dial_code": "+41" },
  "CN": { "name": "China", "dial_code": "+86" },
  "CO": { "name": "Colombia", "dial_code": "+57" },
  "HR": { "name": "Croatia", "dial_code": "+385" },
  "CY": { "name": "Cyprus", "dial_code": "+357" },
  "CZ": { "name": "Czech Republic", "dial_code": "+420" },
  "DK": { "name": "Denmark", "dial_code": "+45" },
  "DE": { "name": "Germany", "dial_code": "+49" },
  "EG": { "name": "Egypt", "dial_code": "+20" },
  "EE": { "name": "Estonia", "dial_code": "+372" },
  "FI": { "name": "Finland", "dial_code": "+358" },
  "FR": { "name": "France", "dial_code": "+33" },
  "GB": { "name": "United Kingdom", "dial_code": "+44" },
  "GR": { "name": "Greece", "dial_code": "+30" },
  "HK": { "name": "Hong Kong", "dial_code": "+852" },
  "HU": { "name": "Hungary", "dial_code": "+36" },
  "IS": { "name": "Iceland", "dial_code": "+354" },
  "IN": { "name": "India", "dial_code": "+91" },
  "ID": { "name": "Indonesia", "dial_code": "+62" },
  "IR": { "name": "Iran", "dial_code": "+98" },
  "IQ": { "name": "Iraq", "dial_code": "+964" },
  "IE": { "name": "Ireland", "dial_code": "+353" },
  "IL": { "name": "Israel", "dial_code": "+972" },
  "IT": { "name": "Italy", "dial_code": "+39" },
  "JP": { "name": "Japan", "dial_code": "+81" },
  "JO": { "name": "Jordan", "dial_code": "+962" },
  "KZ": { "name": "Kazakhstan", "dial_code": "+7" },
  "KE": { "name": "Kenya", "dial_code": "+254" },
  "KR": { "name": "South Korea", "dial_code": "+82" },
  "KW": { "name": "Kuwait", "dial_code": "+965" },
  "LV": { "name": "Latvia", "dial_code": "+371" },
  "LB": { "name": "Lebanon", "dial_code": "+961" },
  "LT": { "name": "Lithuania", "dial_code": "+370" },
  "LU": { "name": "Luxembourg", "dial_code": "+352" },
  "MY": { "name": "Malaysia", "dial_code": "+60" },
  "MT": { "name": "Malta", "dial_code": "+356" },
  "MX": { "name": "Mexico", "dial_code": "+52" },
  "MC": { "name": "Monaco", "dial_code": "+377" },
  "MA": { "name": "Morocco", "dial_code": "+212" },
  "NL": { "name": "Netherlands", "dial_code": "+31" },
  "NZ": { "name": "New Zealand", "dial_code": "+64" },
  "NO": { "name": "Norway", "dial_code": "+47" },
  "PK": { "name": "Pakistan", "dial_code": "+92" },
  "PH": { "name": "Philippines", "dial_code": "+63" },
  "PL": { "name": "Poland", "dial_code": "+48" },
  "PT": { "name": "Portugal", "dial_code": "+351" },
  "QA": { "name": "Qatar", "dial_code": "+974" },
  "RO": { "name": "Romania", "dial_code": "+40" },
  "RU": { "name": "Russia", "dial_code": "+7" },
  "SA": { "name": "Saudi Arabia", "dial_code": "+966" },
  "RS": { "name": "Serbia", "dial_code": "+381" },
  "SG": { "name": "Singapore", "dial_code": "+65" },
  "SK": { "name": "Slovakia", "dial_code": "+421" },
  "SI": { "name": "Slovenia", "dial_code": "+386" },
  "ZA": { "name": "South Africa", "dial_code": "+27" },
  "ES": { "name": "Spain", "dial_code": "+34" },
  "SE": { "name": "Sweden", "dial_code": "+46" },
  "TH": { "name": "Thailand", "dial_code": "+66" },
  "TR": { "name": "Turkey", "dial_code": "+90" },
  "UA": { "name": "Ukraine", "dial_code": "+380" },
  "AE": { "name": "United Arab Emirates", "dial_code": "+971" },
  "US": { "name": "United States", "dial_code": "+1" },
  "UY": { "name": "Uruguay", "dial_code": "+598" },
  "UZ": { "name": "Uzbekistan", "dial_code": "+998" },
  "VE": { "name": "Venezuela", "dial_code": "+58" },
  "VN": { "name": "Vietnam", "dial_code": "+84" }
}; 